import { endpoints } from 'constants/endpoints';

import { sendRequest } from '../sendRequest';

export const getFiltersApi = () => {
  const url = endpoints.analytics.feedback.filters;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getAggregatedScoreApi = ({ cohort, groupByKeys, splitByKeys, graphType, dateRange }) => {
  const url = endpoints.analytics.feedback.aggregatedScore;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      splitByKeys,
      graphType,
      dateRange,
    },
  });
};

export const getTabularDataApi = ({ cohort, groupByKeys, splitByKeys, parentUuid, orderBy, dateRange }) => {
  const url = endpoints.analytics.feedback.tabularData;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      splitByKeys,
      parentUuid,
      orderBy,
      dateRange,
    },
  });
};

/**
 * @deprecated 06-08-2024
 */
export const getTopNResultsApi = ({ cohort, groupByKeys, splitByKeys, orderBy, limit, dateRange, parentUuid }) => {
  const url = endpoints.analytics.feedback.topNResult;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      limit,
    },
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      splitByKeys,
      orderBy,
      dateRange,
      parentUuid,
    },
  });
};

export const getTimelineApi = ({ cohort, groupByKeys, splitByKeys, parentUuid, graphType, dateRange }) => {
  const url = endpoints.analytics.feedback.timeline;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      splitByKeys,
      graphType,
      dateRange,
      parentUuid,
    },
  });
};
export const generateCSVDataApi = ({ cohort, groupByKeys, source, filter, orderBy, dateRange }) => {
  const url = endpoints.analytics.feedback.generateFile;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      source,
      filter,
      orderBy,
      dateRange,
    },
  });
};

export const generateCSVContinousFeedbackDataApi = ({ cohort, groupByKeys, source, filter, orderBy, dateRange }) => {
  const url = endpoints.analytics.continuousFeedback.generateFile;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      source,
      filter,
      orderBy,
      dateRange,
    },
  });
};

export const CFbarGraphData = ({ cohort, groupByKeys, splitByKeys, dateRange }) => {
  const url = endpoints.analytics.continuousFeedback.barGraphData;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      splitByKeys,
      dateRange,
    },
  });
};

export const CfTimelineGraphData = ({ cohort, groupByKeys, splitByKeys, dateRange }) => {
  const url = endpoints.analytics.continuousFeedback.timelineGraph;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      splitByKeys,
      dateRange,
    },
  });
};
